import React, { PropsWithChildren } from 'react'

import { Box, Grid2, useTokens } from '@barracuda-internal/bds-core-v2'

interface AccountSwitcherContainerProps extends PropsWithChildren {
  nonClickable?: boolean
}

const AccountSwitcherContainer = ({ children, nonClickable = false }: AccountSwitcherContainerProps) => {
  const tokens = useTokens()

  return (
    <Grid2
      sx={{
        '& > div': {
          zIndex: 3000,
          '& > div': {
            pointerEvents: nonClickable ? 'none' : 'auto'
          }
        }
      }}
    >
      <Box
        sx={{
          position: 'relative',
          '& > div > div.MuiGrid-root': { background: '#fff' },
          '& > div .MuiInputBase-root > .MuiSelect-select ': {
            color: nonClickable ? tokens.navigationAccountSwitcherColorTextDisabled : undefined
          }
        }}
      >
        {children}
      </Box>
    </Grid2>
  )
}

export default AccountSwitcherContainer
